export const predefinedPlaceholders = [
	"Warlock of the Magus World",
	"Harry Potter and the Deathly Hallows",
	"Lord of the Mysteries",
	"A Black Comedy",
	"The Silmarillion",
	"The Kingkiller Chronicle",
];
